var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mark',{staticClass:"word-highlight",attrs:{"aria-label":((_vm.$t('label.matched_search')) + " " + _vm.text)}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }